import { Button } from '../button';

export function UnsupportedView({
  filename,
  onOpen,
  onDownload,
}: {
  filename: string;
  onOpen: () => void;
  onDownload?: () => void;
}) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-md p-6 text-center">
      <p className="text-sm text-muted-foreground">
        Preview not available for <span className="font-medium text-foreground">{filename}</span>
      </p>
      <div className="flex gap-2">
        <Button type="button" variant="default" size="sm" onClick={onOpen}>
          Open a copy
        </Button>
        {onDownload && (
          <Button type="button" variant="outline" size="sm" onClick={onDownload}>
            Download
          </Button>
        )}
      </div>
      {/* OS-open hands the external app a temp COPY — its edits never write
          back to the workspace, so the card must say so. */}
      <p className="text-xs text-muted-foreground">
        Opens a copy — edits made in another app won’t be saved back to the workspace.
      </p>
    </div>
  );
}
